import { i18n } from 'boot/i18n'
import { getQueryParam } from 'src/utils/utils.js'

export const useUserStore = defineStore('user', () => {
  // State
  let user = ref(null)
  let otp = ref(null)

  // Getters
  const regionalSettings = computed(() => {
    const regionalLang = user.value?.regional_settings ? user.value.regional_settings : i18n.global.locale.value
    return {
      lang: regionalLang,
      dateFormat: regionalLang === 'nl-NL' ? 'dd-MM-yyyy' : 'MM/dd/yyyy',
      dateTimeFormat: regionalLang === 'nl-NL' ? 'dd-MM-yyyy HH:mm' : 'MM/dd/yyyy HH:mm',
      mask: regionalLang === 'nl-NL' ? '##-##-####' : '##/##/####',
      dateTimeMask: regionalLang === 'nl-NL' ? '##-##-#### ##:##' : '##/##/#### ##:##',
    }
  })

  const otpSecret = computed(() => {
    if (otp.value) {
      return getQueryParam(otp.value, 'secret')
    }
    return null
  })

  // Actions can be added here if needed

  return {
    // State
    user,
    otp,

    // Getters
    regionalSettings,
    otpSecret,

    // Actions
  }
})
